import React from "react";

import { TriangleAlert } from "lucide-react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { formatMilesDecimalNew } from "@/services/Utils";
import { getApplicationOrderTypeVariant } from "@/constants/applicationOrderTypes";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import "./OATooltip.scss";

const OATooltip = ({ row, totalRow }) => {
	const orderStatusFinished = parseInt(row?.original.application_orders_state_id) === 5;
	const percent_used = row?.original?.tooltip?.head?.percent_used ? row?.original?.tooltip?.head?.percent_used : "0";
	const percent_pending = row?.original?.tooltip?.head?.percent_pending ? row?.original?.tooltip?.head?.percent_pending : "0";
	const typeOAId = row?.original?.application_order_type_id;
	const typeOADescription = row?.original?.type_oa;
	const oaTypeVariant = getApplicationOrderTypeVariant(typeOAId);

	const middle = totalRow / 2;

	const getUnitMeasure = (unitMeasurement) => {
		if (unitMeasurement === "cc") return "L";
		if (unitMeasurement === "u") return "Un";
		return "Kg";
	};

	const alerticon = () => {
		return (
			<OverlayTrigger
				overlay={
					<Tooltip>
						¡Se están usando productos opcionales por lo que el consumo estimado de cada uno se verá reflejado una vez termine la aplicación!
					</Tooltip>
				}
			>
				<TriangleAlert color={"#d80f0f"} />
			</OverlayTrigger>
		);
	};

	return (
		<div className="tooltip-container">
			<div className="tooltip-code">
				<span>{row.values.code}</span>
				{typeOADescription && (
					<CustomBadge variant={oaTypeVariant} size="sm" style={{ marginLeft: "6px" }}>
						{typeOADescription}
					</CustomBadge>
				)}
			</div>

			<div className="tooltip-content" style={{ top: row.id >= middle && "-10em" }}>
				<div className="tooltip-head">
					<div className="tooltip-percent">
						<span style={{ fontSize: "12px" }}>Pendiente</span>
						<div style={{ color: Number(percent_pending.replace(",", ".")) === 0 ? "green" : undefined }}>
							{Math.min(100, Math.max(0, Number(percent_pending.replace(",", "."))))}%
						</div>
					</div>
					<div className="tooltip-percent">
						<span style={{ fontSize: "12px" }}>Utilizado</span>
						<div style={{ color: Number(percent_used.replace(",", ".")) >= 100 ? "green" : undefined }}>
							{Math.min(100, Math.max(0, Number(percent_used.replace(",", "."))))}%
						</div>
					</div>
				</div>

				<table className="tooltip-table">
					<thead>
						<tr>
							<th>
								<div className="div-title">Producto</div>
							</th>
							<th>
								<div className="div-title">Cant. Planificada </div>
							</th>
							<th>
								<div className="div-title">Cant. En Uso </div>
							</th>
							<th>
								<div className="div-title">Cant. Pendiente</div>
							</th>
							<th>
								<div className="div-title">Cant. Utilizada</div>
							</th>
						</tr>
					</thead>
					<tbody>
						{row?.original?.tooltip?.details.map((item, i) => {
							const unitMeasure = getUnitMeasure(item.unit_measurement);

							if (Number(String(item.total_pending).replace(",", ".")) < 0) {
								item.total_pending = 0;
							}

							return (
								<React.Fragment key={i}>
									<tr>
										<td>{item.product}</td>
										<td>
											{!item.has_active_optionals || orderStatusFinished
												? formatMilesDecimalNew(item.quantity) + unitMeasure
												: alerticon()}
										</td>
										<td>
											{formatMilesDecimalNew(item.total_out)}
											{unitMeasure}
										</td>
										<td>
											{!item.has_active_optionals || orderStatusFinished
												? formatMilesDecimalNew(item.total_pending) + unitMeasure
												: alerticon()}
										</td>
										<td>
											{!item.has_active_optionals || orderStatusFinished
												? formatMilesDecimalNew(item.total_used) + unitMeasure
												: alerticon()}
										</td>
									</tr>
									{item.optional_products?.map((option, j) => {
										const optionUnit = getUnitMeasure(option.unit_measurement);
										if (Number(String(option.total_pending).replace(",", ".")) < 0) {
											option.total_pending = 0;
										}

										return (
											<tr key={`${i}-opt-${j}`} className="tooltip-option-row">
												<td>
													<strong>Opción: </strong>
													{option.product}
												</td>
												<td>
													{!item.has_active_optionals || orderStatusFinished
														? formatMilesDecimalNew(option.quantity) + unitMeasure
														: alerticon()}
												</td>
												<td>
													{formatMilesDecimalNew(option.total_out)}
													{optionUnit}
												</td>
												<td>
													{!item.has_active_optionals || orderStatusFinished
														? formatMilesDecimalNew(option.total_pending) + unitMeasure
														: alerticon()}
												</td>
												<td>
													{!item.has_active_optionals || orderStatusFinished
														? formatMilesDecimalNew(option.total_used) + unitMeasure
														: alerticon()}
												</td>
											</tr>
										);
									})}
								</React.Fragment>
							);
						})}
					</tbody>
				</table>
			</div>
		</div>
	);
};

export default OATooltip;
